import { render, staticRenderFns } from "./TransferMedicationDirectionsComponent.vue?vue&type=template&id=ef50f08c&"
import script from "./TransferMedicationDirectionsComponent.vue?vue&type=script&lang=ts&"
export * from "./TransferMedicationDirectionsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TransferMedicationDirectionsComponent.vue?vue&type=style&index=0&id=ef50f08c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports